module.exports = __webpack_public_path__ + "static/img/motorbike-bluegrey.fbe27ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/motorbike-bluegrey.svg
// module id = Sgk6
// module chunks = 74